export enum OwnerType {
  Course = "Kurs",
  User = "Bruker",
}
